export default "/images/vendor/flag-icon-css/flags/4x3/za.svg?83099da26ad6804ed7a59dfb9b639de0";